import { render, staticRenderFns } from "./AllTablesView.vue?vue&type=template&id=af32ba48"
import script from "./AllTablesView.vue?vue&type=script&lang=js"
export * from "./AllTablesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports